export const notes = ['C', 'G', 'D', 'A', 'E', 'B', 'Gb', 'Db', 'Ab', 'Eb', 'Bb', 'F',
    'Am', 'Em', 'Bm', 'FShm', 'CShm', 'GShm', 'Ebm', 'Bbm', 'Fm', 'Cm', 'Gm', 'Dm'];
